<template>
  <v-row
    style="display: flex; flex-direction: row; justify-content: space-around"
  >
    <v-menu
      ref="menuFrom"
      v-model="menuFrom"
      offset-y
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="timeFrom"
          label="Desde"
          rounded
          filled
          v-bind="attrs"
          v-on="on"
          :rules="rules"
          required
          style="max-width: 200px"
          class="ml-5"
        ></v-text-field>
      </template>
      <v-time-picker
        v-model="timeFrom"
        class="mt-4"
        scrollable
        format="24hr"
        :min="minFrom"
        :max="maxFrom"
        @click="$refs.menuFrom.save(timeFrom)"
      >
        <v-btn
          text
          color="primary"
          @click="menuFrom = false"
          class="v-picker__actions"
        >
          Aceptar
        </v-btn>
      </v-time-picker>
    </v-menu>
    <v-menu
      ref="menu"
      v-model="menuTo"
      offset-y
      :close-on-content-click="false"
      :nudge-right="40"
      transition="scale-transition"
    >
      <template v-slot:activator="{ on, attrs }">
        <v-text-field
          v-model="timeTo"
          label="Hasta"
          :rules="rules"
          v-bind="attrs"
          v-on="on"
          rounded
          filled
          style="max-width: 200px"
          class="mr-5"
        ></v-text-field>
      </template>
      <v-time-picker
        v-model="timeTo"
        class="mt-4"
        format="24hr"
        scrollable
        :min="minTo"
        :max="maxTo"
        @click="$refs.menuTo.save(timeTo)"
      >
        <v-btn
          text
          color="primary"
          @click="menuTo = false"
          class="v-picker__actions"
        >
          Aceptar
        </v-btn>
      </v-time-picker>
    </v-menu>
  </v-row>
</template>

<script>
import registrations from "@/store/gestionTiempos/registrations";

export default {
  props: {
    minFrom: String,
    maxFrom: String,
    minTo: String,
    maxTo: String,
  },
  data() {
    return {
      menuFrom: false,
      menuTo: false,
      rules: [(v) => !!v || this.$tc("editRegistrations.requerid")],
    };
  },

  computed: {
    timeFrom: {
      get: function () {
        return registrations.state.dateFrom;
      },
      set: function (newDate) {
        this.setDate(newDate);
      },
    },
    timeTo: {
      get: function () {
        return registrations.state.dateTo;
      },
      set: function (newDate) {
        this.setDateTo(newDate);
      },
    },
  },
  methods: {
    setDate(date) {
      registrations.commit("setDateFrom", date);
    },
    setDateTo(date) {
      registrations.commit("setDateTo", date);
    },
  },
};
</script>

<style scoped>
.v-picker__actions {
  min-width: 100% !important;
  display: flex !important;
  justify-content: flex-end !important;
}
</style>
